import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";
import Loading from "../../shared/loading";
import SessionController from "../../shared/session";
import RouterService from "../../shared/services/router.service";
import AuthLogo from "../../shared/components/component_logo";

let loading = true;
let loginError = false;
let accessToken;

const PublicPage_ValidateAccessToken = {
    oninit: function (vnode) {
        accessToken = vnode.attrs.token;
        loading = true;
        SessionController.clearSession();
        Requester.post(Gateway.public + `id/validate-accessToken/${accessToken}`)
                .then(function (result) {
                    if(result) {
                        SessionController.setSession(result)
                            .then(function () {
                                RouterService.navigateToPublicCourses();
                            });
                    } else {
                        loginError = true;
                    }
                })
                .catch(function (error) {
                    loginError = true;
                    Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
                })
                .finally(function () {
                    loading = false;
                });
    },
    view: function () {
        return [
            m(".splash-container", [
                loading ? m(Loading, {class: "loading-inline"})
                    : loginError ? [
                        m(AuthLogo),
                        m(".mt-2.pt-2.text-center", [
                            m("i.icon-info.text-danger.icon-big"),
                            m("h3.mb-2", i18n.t("something_went_wrong")),
                            m(".mb-2.pb-2", i18n.t("please_try_again_or_contact_support")),
                            m(m.route.Link, {href: RouterService.getPublicLoginUrl(), class: "btn"}, i18n.t("back_to_login"))
                        ])
                    ] : ""
            ])
        ];
    }
};

export default PublicPage_ValidateAccessToken;
